/**
 * iurop-product-card.js — Quick-add desde la product card (Apodemia)
 * - Click en una variante: la marca como seleccionada (subrayada).
 * - Click en "Añadir": POST /cart/add con la variante seleccionada (o la por
 *   defecto) y dispara `cart:updated` → iurop-cart-drawer.js refresca y abre el
 *   sidecart. Delegación global (funciona con cards inyectadas dinámicamente).
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    // --- Selección de variante ---------------------------------------------
    var vbtn = e.target.closest('[data-variant-id]');
    if (vbtn && !vbtn.disabled) {
      var group = vbtn.closest('[data-variants]');
      if (group) {
        group.querySelectorAll('[data-variant-id]').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        vbtn.classList.add('is-selected');

        // Actualiza el precio de la card al precio de la variante elegida.
        var pcard = vbtn.closest('[data-product-card]');
        if (pcard) {
          var now = pcard.querySelector('[data-card-now]');
          var was = pcard.querySelector('[data-card-was]');
          var vp = vbtn.getAttribute('data-variant-price');
          var vc = vbtn.getAttribute('data-variant-compare');
          if (now && vp) now.textContent = vp;
          if (was) {
            if (vc) { was.textContent = vc; was.hidden = false; }
            else { was.textContent = ''; was.hidden = true; }
          }
        }
      }
      return;
    }

    // --- Quick-add ----------------------------------------------------------
    var add = e.target.closest('[data-quick-add]');
    if (!add || add.classList.contains('is-loading')) return;
    e.preventDefault();

    var card = add.closest('[data-product-card]');
    var selected = card && card.querySelector('[data-variant-id].is-selected');
    var id = selected ? selected.getAttribute('data-variant-id') : add.getAttribute('data-default-variant');
    if (!id) return;

    // Sidecart fluido: abre al instante con la línea provisional.
    if (window.IuropCart && window.IuropCart.add) {
      var img = card && card.querySelector('.apodemia-product-card__img--primary, .apodemia-product-card__img');
      var title = card && card.querySelector('.apodemia-product-card__title');
      var price = card && card.querySelector('.apodemia-product-card__price');
      var priceNow = price ? price.cloneNode(true) : null;
      if (priceNow) priceNow.querySelectorAll('s, .apodemia-product-card__price-was').forEach(function (x) { x.remove(); });
      add.classList.add('is-loading');
      var addLabel = add.textContent;
      if (add.getAttribute('data-adding-text')) add.textContent = add.getAttribute('data-adding-text');
      window.IuropCart.add([{ id: id, quantity: 1 }], [{
        title: title ? title.textContent.trim() : '',
        image: img ? (img.currentSrc || img.src) : '',
        price: priceNow ? priceNow.textContent.trim() : '',
        variant: selected ? (selected.textContent || '').trim() : ''
      }])
        .then(function () {
          add.classList.add('is-added');
          window.setTimeout(function () { add.classList.remove('is-added'); }, 1500);
        })
        .catch(function () {})
        .then(function () {
          add.classList.remove('is-loading');
          add.textContent = addLabel;
        });
      return;
    }

    add.classList.add('is-loading');
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (res) {
        add.classList.remove('is-loading');
        if (!res.ok) return;
        add.classList.add('is-added');
        window.setTimeout(function () { add.classList.remove('is-added'); }, 1500);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product-card' } }));
      })
      .catch(function () {
        add.classList.remove('is-loading');
      });
  });
})();
